import { CurrencyField, WorkTimeField } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { useCustomRepairTimesDefaults } from "@tm/data/basket"

export function FixedPriceFields() {
    const { translateText } = useLocalization()
    const { control } = useFormContext()
    const { customRepairTimesDefaults: { defaultCurrencyCode } = {} } = useCustomRepairTimesDefaults()

    return (
        <>
            <Controller
                control={control}
                name="workTime"
                render={({ field, fieldState }) => (
                    <WorkTimeField label={translateText(84)} size="extralarge" sx={{ width: "150px" }} {...field} {...errorHandling(fieldState)} />
                )}
            />
            <Controller
                control={control}
                name="fixedPriceValue"
                render={({ field, fieldState }) => (
                    <CurrencyField
                        required
                        label={`${translateText(246)} ${defaultCurrencyCode}`}
                        size="extralarge"
                        sx={{ width: "150px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
        </>
    )
}
